//
// Telemetry recorder.
function ANTelemetryRecorder(eventName, intervalTimeInMinutes = 0.25, reduceSendFrequency = false){

    this.__eventName           = eventName;
    this.__interval            = null;
    this.__logger              = new AdsNinjaLogger();
    this.__brandName           = window.adsNinjaHeaderBiddingManager.getBrandName();
    this.__waitingResponse     = false;
    this.__counters            = {};
    this.__reduceSendFrequency = reduceSendFrequency;
    var self                   = this;

    if(!this.__isEnabledForBrand()){

        this.__logger.debug('Sending telemetry records is disabled.', {
            eventName: this.__eventName,
        }, false);
        return;
    }
    else{

        this.__logger.debug('Sending telemetry records is enabled.', {
            eventName: this.__eventName,
        }, false);
    }

    if(this.__reduceSendFrequency){
        
        // Setup interval time.
        this.__interval = setInterval(function(){
            
            self.handleTimeToSendData('time');
        }, intervalTimeInMinutes * 60 * 1000);

        // Setup event listeners.
        window.addEventListener('beforeunload', this.handleTimeToSendData.bind(this, 'beforeunload'));
        window.addEventListener('visibilitychange', function(){

            if('visible' === document.visibilityState){

                return;
            }

            self.handleTimeToSendData('visibilitychange');
        });
    }
}

//
// Reset counter.
ANTelemetryRecorder.prototype.__reset = function(){
    
    this.__counters = {};
};

//
// Increment counter.
// TODO: Can make more dynamic by accepting an object with entries we'd use to construct the key.
ANTelemetryRecorder.prototype.increment = function(adUnitName, requestType, isInflation){
    
    // ANTelemetryRecorder.prototype.increment = function(requestType, isInflation, hasPrebidBid, prebidBidIsFromPool, hasAmazonBid, amazonBidIsFromPool){

    var key = `${adUnitName}_${requestType}_${isInflation}`;
    // var key = `${requestType}-${isInflation}-${hasPrebidBid}-${prebidBidIsFromPool}-${hasAmazonBid}-${amazonBidIsFromPool}`;

    if(!this.__counters.hasOwnProperty(key)){

        this.__counters[key] = {
            'adUnitName': adUnitName,
            'requestType': requestType,
            'isInflation': isInflation,
            // 'hasPrebidBid': hasPrebidBid,
            // 'prebidBidIsFromPool': prebidBidIsFromPool,
            // 'hasAmazonBid': hasAmazonBid,
            // 'amazonBidIsFromPool': amazonBidIsFromPool,
            'count': 0,
        };
    }

    this.__counters[key]['count']++;

    if(!this.__reduceSendFrequency && this.__isEnabledForBrand()){
        
        this.handleTimeToSendData('increment');
        this.__reset();

        this.__waitingResponse = false;
    }
};

//
// Success callback.
ANTelemetryRecorder.prototype.__successCallback = function(response){

    this.__logger.debug('Sent telemetry event.', {
        response: response,
        eventName: this.__eventName,
        counters: self.__counters,
    });

    this.__reset();

    this.__waitingResponse = false;
};

//
// Error callback.
ANTelemetryRecorder.prototype.__errorCallback = function(status, response, isSendingDisabled){

    if(!isSendingDisabled){

        this.__logger.error('Failed to send telemetry event.', {
            status: status,
            response: response,
            eventName: this.__eventName,
            counters: self.__counters,
        });
    }
    else{

        this.__logger.debug('Failed to send telemetry event. Telemetry is disabled.', {
            status: status,
            response: response,
            eventName: this.__eventName,
            counters: self.__counters,
        });
    }

    this.__waitingResponse = false;
};

//
// Handle time to send data.
ANTelemetryRecorder.prototype.handleTimeToSendData = function(initiator){

    if(!this.__isEnabledForBrand() || this.__waitingResponse || !this.__counters || typeof this.__counters !== 'object' || Object.keys(this.__counters).length === 0){

        return;
    }

    if(!window.adsNinja || !window.adsNinja.queue){

        this.__logger.error('AdsNinja queue is not defined.');
        return;
    }

    this.__waitingResponse = true;
    var self               = this;

    window.adsNinja.queue.push(function(){

        var data = {
            eventName: self.__eventName,
            counts: self.__counters,
            initiator: initiator,
        };

        window.adsNinja.sendTelemetryEvent(
            'data',
            `Number of "${self.__eventName}" events counted so far.`, 
            data,
            self.__successCallback.bind(self),
            self.__errorCallback.bind(self),
            false
        );
    });
};

//
// Check if enabled for brand.
ANTelemetryRecorder.prototype.__isEnabledForBrand = function(){

    return false;
};

window.ANTelemetryRecorder = ANTelemetryRecorder;